/**
 * Application configuration constants
 * Centralized constants for roles, features, components, routes, and architectural patterns
 */

// Feature IDs - Application feature definitions
export const FEATURE_IDS = {
  CORE_NAVIGATION: 'core-navigation',
  ACCOUNT_MANAGEMENT: 'account-management',
  DIARY_MANAGEMENT: 'diary-management',
  THREAD_SUMMARISATION: 'thread-summarisation',
  MEETING_AVAILABILITY: 'meeting-availability',
  ROBIN_CHAT: 'robin-chat',
  ACTION_ITEMS: 'action-items',
  MORNING_DASHBOARD: 'dashboard-v2',
  HANDOVER_SUPPORT: 'handover-support',
  INSIGHTS_HUB: 'insights-hub',
} as const;

// Component IDs - UI component identifiers
export const COMPONENT_IDS = {
  // Panel Components
  MY_ACCOUNT_PANEL: 'my-account-panel',
  DIARY_MANAGEMENT_PANEL: 'diary-management-panel',
  THREAD_SUMMARISATION_PANEL: 'thread-summarisation-panel',
  MEETING_AVAILABILITY_PANEL: 'meeting-availability-panel',
  ACTION_ITEMS_PANEL: 'tasks-panel',
  MORNING_DASHBOARD_PANEL: 'morning-dashboard-panel',
  HANDOVER_SUPPORT_PANEL: 'handover-support-panel',
  INSIGHTS_HUB_PANEL: 'insights-hub-panel',

  // Widgets
  TASKS_WIDGET: 'tasks-widget',
  MEETING_WIDGET: 'meeting-widget',
  COLLEAGUES_WIDGET: 'colleagues-widget',
  SHORTCUTS_WIDGET: 'shortcuts-widget',
} as const;

// Page Paths - Application route definitions
export const PAGE_PATHS = {
  DASHBOARD: '/dashboard',
  DEBUG: '/debug',
  COMPONENTS: '/components',
  TESTER_AID: '/tester-aid',
  ROBIN_CHAT: '/robin-chat',
  INSIGHTS_HUB: '/dashboard/insights-hub',
  INSIGHTS_HUB_CARD: '/dashboard/insights-hub/:id',
} as const;

// Role IDs - Entra role names returned by /api/v1/profile/me
export const ROLE_IDS = {
  USER: 'User',
  EXECUTIVE_ASSISTANT: 'Executive Assistant',
} as const;

// Type helpers derived from constants
export type FeatureIdConstant = (typeof FEATURE_IDS)[keyof typeof FEATURE_IDS];
export type ComponentIdConstant = (typeof COMPONENT_IDS)[keyof typeof COMPONENT_IDS];
export type PagePathConstant = (typeof PAGE_PATHS)[keyof typeof PAGE_PATHS];
export type RoleIdConstant = (typeof ROLE_IDS)[keyof typeof ROLE_IDS];
